import { DELETE, POST } from '../apiController';

const USER_NOTIFICATION_BASE = '/user/usernotification';

export function registerWebPushDeviceToken(data) {
  return POST(`${USER_NOTIFICATION_BASE}/device-tokens`, data);
}

export function unregisterWebPushDeviceToken(data) {
  return DELETE(`${USER_NOTIFICATION_BASE}/device-tokens`, data);
}
